"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@/config/utils");
const vue_1 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    name: 'NumberUnit',
    props: {
        unit: {
            type: String,
            required: true
        },
        unitOption: {
            type: Object,
            required: false,
            default: undefined
        }
    },
    computed: {
        unitStyle() {
            const unitStyle = {};
            if (this.unitOption) {
                if (this.unitOption.color) {
                    unitStyle.color = this.unitOption.color;
                }
                if (this.unitOption.fontSize) {
                    unitStyle.fontSize = (0, utils_1.formatStyle)(this.unitOption.fontSize);
                }
                if (this.unitOption.lineHeight) {
                    unitStyle.lineHeight = (0, utils_1.formatStyle)(this.unitOption.lineHeight);
                }
                if (this.unitOption.top) {
                    unitStyle.transform = `translateY(${(0, utils_1.formatStyle)(this.unitOption.top)})`;
                }
                if (this.unitOption.left) {
                    unitStyle.marginLeft = (0, utils_1.formatStyle)(this.unitOption.left);
                }
            }
            return unitStyle;
        }
    }
});
